import { Chip, type ChipProps } from '@mui/material';
import { allTokens } from '../../../lib/tokens';

/**
 * Whether an invoice is ready for the dealer to act on. A chip rather than a
 * dimmed row, because dimming is the signal a dealer on a bright screen is most
 * likely to miss, and colour is never the only thing carrying a state.
 *
 * The words are the dealer's, not the database's. An invoice the billing
 * system calls `closed` is one this dealer can now pay, which is what
 * "prepared" says. Everything before that is still being built.
 */
export interface InvoiceStatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  status: string | null | undefined;
}

const PREPARED_STATUS = 'closed';

export default function InvoiceStatusChip({ status, sx, ...rest }: InvoiceStatusChipProps) {
  const prepared = status === PREPARED_STATUS;

  return (
    <Chip
      size='small'
      label={prepared ? 'Prepared' : 'Not prepared'}
      sx={{
        bgcolor: prepared ? allTokens.palette.info[50] : allTokens.palette.grey[100],
        color: prepared ? allTokens.palette.info[700] : allTokens.palette.grey[700],
        fontWeight: 600,
        ...sx,
      }}
      {...rest}
    />
  );
}
